<template>
  <div class="mb-3">
    <p class="font-w600">Reading Value</p>
    <p>{{ reading.value }}</p>
  </div>

  <div class="mb-3">
    <p class="font-w600">Reading Date</p>
    <p>{{ reading.submittedAt.toLocaleString() }}</p>
  </div>

  <div class="mb-3">
    <p class="font-w600">Meter Reset?</p>
    <p>{{ reading.isReset ? 'Yes' : 'No' }}</p>
  </div>

  <div class="mb-3" v-if="reading.units">
    <p class="font-w600">Override Units</p>
    <p>{{ reading.units }}</p>
  </div>

  <div class="mb-3" v-if="reading.factor">
    <p class="font-w600">Override Factor</p>
    <p>{{ reading.factor }}</p>
  </div>

  <div class="mb-3" v-if="reading.note">
    <p class="font-w600">Note</p>
    <p>{{ reading.note }}</p>
  </div>

  <div v-if="displayUrl">
    <div class="photo">
      <img :src="displayUrl" alt="photo" />
    </div>
  </div>
  <div v-else-if="photoLoading" class="text-muted">Loading photo…</div>
</template>
<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue';
import type { WizardState } from '@/stores/wizard';
import { useStore as useReadingStore } from '@/stores/reading';

const props = defineProps<{
  reading: WizardState['reading'];
  photoData: WizardState['photoData'];
  // Present once the reading is submitted; its photo (if any) lives in S3 and
  // is fetched on demand rather than retained in the queue.
  readingId?: string | null;
  // Whether this reading was submitted with a photo. Submitted items have had
  // their local base64 cleared, so this tells us to bother fetching from S3.
  hasPhoto?: boolean;
}>();

const readingStore = useReadingStore();

const remoteUrl = ref<string | null>(null);
const photoLoading = ref(false);

const displayUrl = computed(() => props.photoData.dataUrl || remoteUrl.value);

onMounted(async () => {
  // Local base64 still present (unsent reading) — nothing to fetch.
  if (props.photoData.dataUrl) return;
  // No persisted reading, or it had no photo — nothing to show.
  if (!props.readingId || !props.hasPhoto) return;

  photoLoading.value = true;
  remoteUrl.value = await readingStore.getPhotoUrl(props.readingId);
  photoLoading.value = false;
});
</script>
